import React from 'react'
import Menu from './Menu.jsx'
import { ViewerContext } from '../context/ViewerContext.jsx'
import classnames from 'classnames'

class FlyoutMenu extends React.Component {
  menuClick = e => {
    e.preventDefault()
    this.props.updateSidebar(this.props.position, e.currentTarget.value)
  }

  render() {
    const getToggleClass = classnames('flyout', {
      'flyout--open-33 flyout--open':
        this.context.state.toggledSetting === 'one',
      'flyout--open-55 flyout--open':
        this.context.state.toggledSetting === 'both',
      'flyout--drawer-toggled': this.context.state.drawerToggled === true,
    })
    return (
      <div className={getToggleClass}>
        <div className="flyout__scroll js-flyout__scroll">
          <Menu
            shown={this.context.state.toggledSetting}
            currentView={this.context.state.leftFlyoutContent}
            updateSidebar={this.context.updateSidebar}
            content={this.props.content}
            panesFlipped={this.context.state.panesFlipped}
            position="left"
            reverseContent={this.context.reverseContent}
            highlightedSection={this.context.state.highlightedSection}
            currentFootnotes={this.context.state.currentFootnotes}
            updateFootnote={this.context.updateFootnote}
            toggleDrawer={this.context.toggleDrawer}
            showAllFootnotes={this.context.showAllFootnotes}
          />
          <Menu
            shown={this.context.state.toggledSetting}
            currentView={this.context.state.rightFlyoutContent}
            current
            updateSidebar={this.context.updateSidebar}
            content={this.props.content}
            panesFlipped={this.context.state.panesFlipped}
            position="right"
            reverseContent={this.context.reverseContent}
            highlightedSection={this.context.state.highlightedSection}
            currentFootnotes={this.context.state.currentFootnotes}
            updateFootnote={this.context.updateFootnote}
            toggleDrawer={this.context.toggleDrawer}
            showAllFootnotes={this.context.showAllFootnotes}
          />
        </div>
      </div>
    )
  }
}
FlyoutMenu.contextType = ViewerContext
export default FlyoutMenu
